import {
  AddOnsState,
  CenterServicesState,
  Coupon,
} from "../AppointmentBookingContext/types";

export const checkIsCouponSelected = ({
  selectedCenterServices,
  selectedAddOns,
  coupon,
}: {
  selectedCenterServices: CenterServicesState;
  selectedAddOns: AddOnsState;
  coupon: Coupon;
}) => {
  const studyAddOnIds = selectedCenterServices.flatMap(
    (service) => service?.addOnIds,
  );

  const addOnIds = selectedAddOns.map((addOn) => addOn.id);

  const isSelected = [...studyAddOnIds, ...addOnIds].some(
    (id) => id === coupon.addOnId,
  );

  return isSelected;
};
